import React from "react";
import { BorrowerLeadGenerationTool } from 'borrower-lead-generation-tool';
import "./index.css";
 
export default function JourneySection({ data }) {
  const inspiredData = data?.inspiredSection;
  
  if (!inspiredData) {
    return null;
  }
  
  return (
    <section className="inspired-section ">
      <div className="container borrower-form-container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8 text-center">
            <h2 className="inspired-heading">
              <span className="text-orange">{inspiredData.headingLine1}</span>
              <br />
              <span className="text-navy">{inspiredData.headingLine2}</span>
            </h2>
            
            {/* Borrower Lead Generation Form directly embedded */}
            <div className="borrower-lead-form">
              <BorrowerLeadGenerationTool
                loanOfficerId=""
                branchCode="058"
                leadSrc="NET001"
                loanPurpKeyword=""
                formHeading="Apply Now"
                statesDomain="ny.swmc.com"
                domainNameConsent="swmc.com"
                language="en"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}